import { Observer, observer } from 'mobx-react-lite'
import { TextArea, type TextAreaProps } from '@/components/inputs/TextArea'
import type { FilterProps } from '@/infra/type-utils'
import {
  type ContainerProps,
  FormFieldContainer,
} from '@/components/FormContainer'
import { action } from 'mobx'

/**
 * Form field container for a {@link TextArea}.
 */
export const TextAreaContainer = observer(function TextAreaContainer<
  M extends object,
  K extends keyof FilterProps<M, string>,
>({
  name,
  model,
  label,
  hint,
  field,
  error,
  hintTestId,
  'aria-label': ariaLabel,
  ...rest
}: ContainerProps<M, string, K, Omit<TextAreaProps, 'value'>>) {
  return (
    <FormFieldContainer
      name={name}
      model={model}
      label={label}
      hint={hint}
      field={field}
      error={error}
      aria-label={ariaLabel}
      hintTestId={hintTestId}
      render={(controlProps) => (
        // Using `Observer` here makes it so only the `TextArea`
        // re-renders when the value changes.
        <Observer>
          {() => (
            <TextArea
              {...controlProps}
              value={model[field] as string}
              onChange={action(`change ${field}`, (event) => {
                model[field] = event.target.value as M[K]
              })}
              {...rest}
            />
          )}
        </Observer>
      )}
    />
  )
})
